import BasicModal from "./BasicModal";

import Lottie from "lottie-react";

import loadingAnimation from "./../../Assets/animation/loading.json";

function LoadingModal(loadingProps) {
  const { isLoading } = loadingProps;

  return (
    <BasicModal
      isVisible={isLoading}
      setIsVisible={false}
      header="Loading"
      showHeader={false}
    >
      <div className=" flex flex-col justify-center items-center  bg-white rounded-md   w-[90vw] md:w-[30vw]">
        <div style={{ width: "40%" }}>
          <Lottie animationData={loadingAnimation} />
        </div>
        <div
          className=" flex justify-center py-2 text-3xl font-semibold animate-pulse "
          style={{ color: "rgba(0,0,0,0.2)" }}
        >
          ... Loading
        </div>
      </div>
    </BasicModal>
  );
}

export default LoadingModal;
